// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"bbb_a"};